import { LEAD_SOURCE_LEVEL, PAGESIZE_ALL, TREATMENT_FREE, TYPE_CARD } from "app/common/LocalConst";
import { getPriceTypeService } from "app/common/LocalFunction";
import { RegisterService } from "app/common/Model/RegisterService";
import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import { pagingClientCard } from "app/services/ClientCardService";
import { getListCode } from "app/services/CustomerSourceService";
import { elasticPatientServiceRegisterHistory } from "app/services/ElasticPatient";
import {
  changePaSvRes,
  initChangePaSvRes,
  pagingServiceItem,
  updateMainServiceRegister,
  updateTotalTreatmentTimesOfService,
} from "app/services/PatientServiceRegisterService";
import { pagingRegisterServiceHistory } from "app/services/RegisterServiceHistoryService";
import { getTreatmentTimesEachServices } from "app/services/ServiceRequestItem";
import {
  getHospitalBedSVRequestById,
  lockService,
  pagingServiceRequestItemByPatientServiceRegisterInfoGroupDate,
  saveServiceItem,
  unLockService,
  voidSvitemAndOrther,
} from "app/services/ServiceRequestItemService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
export default class AllServicesTabStore {
  searchAllServices = {
    ...new SearchObject(),
    fromDate: new Date(new Date().getFullYear(), 0, 1),
    toDate: new Date(),
  };
  dataAllServices = [];
  pageAllServices = new PageResponse();
  openChangeServicePopup = false;
  openCreateOrEditServicePopup = false;
  initRegisterService = { ...new RegisterService() };
  initChangeService = {
    oldPatientServiceRegister: {
      ...new RegisterService(),
    },
    newPatientServiceRegisterDto: {
      ...new RegisterService(),
    },
  };
  searchRegisterServiceHistory = {
    ...new SearchObject(),
    patientServiceRegisterId: null,
  };
  openConfirmUnlock = null;
  openConfirmLock = null;
  openConfirmError = null;
  openConfirmDelete = null;
  openConfirmMessage = null;
  treatmentFree = null;
  openRegisterServiceHistoryPopup = false;
  selectRegisterServiceId = null;
  dataRegisterServiceHistory = null;
  openHistoryServicePopup = false;
  searchDataHistory = null;
  pageDataHistory = new PageResponse();
  openUpdateTotalTreatment = null;
  openTreatmentTimesEachServicesConfirm = null;
  openHistoryTreamentServicePopup = false;
  pageHistoryTreamentService = new PageResponse();
  searchHistoryTreamentService = new SearchObject();
  openFormMainServiceRegister = false;
  initialMainServiceRegister = null;
  openWarrantyServicePopup = false;
  initialWarrantyService = null;

  constructor() {
    makeAutoObservable(this);
  }
  pagingAllServices = async () => {
    return await pagingServiceItem({
      ...this.searchAllServices,
      getStaffRevenues: true,
      getAllServiceInTreatment: true,
    })
      .then(({ data }) => {
        this.pageAllServices = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu tất cả dịch vụ có lỗi");
      });
  };

  handleChangeFormSearchService = (searchAllServices) => {
    this.searchAllServices = {
      ...this.searchAllServices,
      ...searchAllServices,
    };
    this.pagingAllServices();
  };

  saveOrUpdateRegisterService = async (values) => {
    return await saveServiceItem(values)
      .then(({ data }) => {
        if (data?.responseStatus === false) {
          toast.error(data?.responseDetail || "Cập nhật dịch vụ thất bại");
          return;
        }
        toast.success("Cập nhật dịch vụ thành công");
        this.pagingAllServices();
        this.openCreateOrEditServicePopup = false;
      })
      .catch((error) => {
        console.error(error);
        let message = "Chỉnh sửa thông tin đăng ký dịch vụ có lỗi";
        if (error?.response?.data?.message) {
          message = error.response.data.message;
        } else if (typeof error?.response?.data === "string" && error.response.data) {
          message = error.response.data;
        } else if (error?.message) {
          message = error.message;
        }
        toast.error(message);
      });
  };

  handleOpenChangeServicePopup = async (service) => {
    try {
      let searchCodeSource = {};
      const { data } = await initChangePaSvRes(service?.id);
      if (data) {
        let { oldPatientServiceRegister } = data;

        // const formatStaffRevenues =
        //   oldPatientServiceRegister?.staffRevenues?.map((el) => ({
        //     ...el,
        //     actualAmount: 0,
        //     oldPercentRevenue: el?.percentRevenue,
        //   }));

        this.initChangeService = {
          oldPatientServiceRegister,
          // staffRevenues: formatStaffRevenues,
          staffRevenues: [],
          oldCredit: oldPatientServiceRegister?.remainingAmount,
          quantity: 1,
          clientCard: this.treatmentFree,
          startDate: new Date(),
          ...data,
        };

        this.openChangeServicePopup = true;
        searchCodeSource = {
          level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
          startDate: this.initChangeService?.startDate || new Date(),
          patientId: oldPatientServiceRegister?.patient?.id,
          departmentId: oldPatientServiceRegister?.department?.id,
          // voucherIds:
          // invoiceItemIds:
        };
        this.handleGetListCodeSource(searchCodeSource);
      }
    } catch (error) {
      toast.error("Lấy thông tin dịch vụ có lỗi");
    }
  };

  handleCloseChangeServicePopup = () => {
    this.openChangeServicePopup = false;
  };

  handleSubmitChangeService = async (values) => {
    try {
      let {
        newPatientServiceRegister,
        oldPatientServiceRegister,
        ...ortherData
      } = values;
      let obj = {
        oldPatientServiceRegister,
        newTreatmentPlanCard: ortherData,
      };
      const { data } = await changePaSvRes(obj);

      if (data?.responseStatus === false) {
        setTimeout(() => {
          this.openConfirmMessage = data?.responseDetail;
        }, 500);
        return data;
      } else {
        this.openChangeServicePopup = false;
        this.pagingAllServices();
        toast.success("Đổi dịch vụ thành công");
      }
    } catch (error) {
      console.error(error);
      toast.error("Đổi dịch vụ có lỗi");
    }
  };

  handleCloseCreateOrEditServicePopup = () => {
    this.openCreateOrEditServicePopup = false;
    this.initRegisterService = { ...new RegisterService() };
  };

  handleOpenConfirmlock = (id) => {
    this.openConfirmLock = id;
  };

  handleCloseConfirmLock = () => {
    this.openConfirmLock = null;
  };

  handleOpenConfirmUnlock = (id) => {
    this.openConfirmUnlock = id;
  };

  handleCloseConfirmUnlock = () => {
    this.openConfirmUnlock = null;
  };

  handleOpenConfirmError = () => {
    this.openConfirmError = null;
  };

  handleConfirmUnlock = async () => {
    try {
      const { data } = await unLockService(this.openConfirmUnlock);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          this.openConfirmError = data?.responseDetail;
        }, 300);
      } else {
        toast.success("Mở khóa thành công");
        this.pagingAllServices();
      }
      this.openConfirmUnlock = null;
    } catch (error) {
      toast.error(error);
    }
  };

  handleConfirmLock = async () => {
    try {
      const { data } = await lockService(this.openConfirmLock);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          this.openConfirmError = data?.responseDetail;
        }, 300);
      } else {
        toast.success("Khóa thành công");
        this.pagingAllServices();
      }
      this.openConfirmLock = null;
    } catch (error) {
      toast.error(error);
    }
  };

  handleOpenCreateOrEditServicePopup = async (serviceRegister, patient, defaultDepartment) => {
    let searchCodeSource = {};
    if (Boolean(serviceRegister)) {
      getHospitalBedSVRequestById(serviceRegister?.id).then(({ data }) => {
        data.totalAmount = data?.quantity * data?.price;
        if (data?.taxPercent) data.taxPercent = data?.taxPercent?.toString();
        if (data?.service) {
          data.groupId = data?.service?.serviceGroup;
          let feeItem = getPriceTypeService(
            data?.service?.patientTypeService,
            data?.service?.serviceFeeList
          );
          data.patientTypeService = {
            ...feeItem?.patientTypeService,
            price: feeItem?.price,
          };
          data.groupId = data?.service?.serviceGroup;
        }
        this.initRegisterService = {
          ...data,
          isDisabled: serviceRegister?.isDisabled,
        };
        this.openCreateOrEditServicePopup = true;
        searchCodeSource = {
          level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
          visitId: this.initRegisterService?.visit?.id,
          patientId: patient?.id || this.initRegisterService?.patientId,
          departmentId: this.initRegisterService?.department?.id,
          voucherIds: Array.isArray(this.initRegisterCard?.voucherAllocations)
            ? this.initRegisterCard?.voucherAllocations
              .map(item => item?.voucher?.id)
              .filter(Boolean)
            : [],
          invoiceItemIds: Array.isArray(this.initRegisterCard?.invoiceItemAllocations)
            ? this.initRegisterCard?.invoiceItemAllocations
              .map(item => item?.invoiceItem?.id)
              .filter(Boolean)
            : [],
        }
        this.handleGetListCodeSource(searchCodeSource)
      });
    }
  };

  listCodeSource = [];

  handleGetListCodeSource = async (obj) => {
    try {
      const { data } = await getListCode(obj);
      this.listCodeSource = data || [];
    } catch (error) {
      //console.error(error);
    }
  }

  handleOpenConfirmDelete = (id) => {
    this.openConfirmDelete = id;
  };

  handleDeleteService = async () => {
    return await voidSvitemAndOrther(this.openConfirmDelete)
      .then(({ data }) => {
        this.openConfirmDelete = null;
        if (data?.responseStatus === false) {
          setTimeout(() => {
            this.openConfirmError = data?.responseDetail;
          }, 300);
          return;
        } else {
          toast.success("Xóa dịch vụ thành công");
          this.pagingAllServices();
        }
      })
      .catch((error) => {
        console.error(error);
        let message = "Xóa dịch vụ có lỗi";
        if (error?.response?.data?.message) {
          message = error.response.data.message;
        } else if (typeof error?.response?.data === "string" && error.response.data) {
          message = error.response.data;
        } else if (error?.message) {
          message = error.message;
        }
        toast.error(message);
      });
  };

  resetPopupStore = () => {
    this.initRegisterService = { ...new RegisterService() };
    this.openCreateOrEditServicePopup = false;
  };

  handleOpenRegisterServiceHistoryPopup = () => {
    this.openRegisterServiceHistoryPopup = true;
  };

  handleCloseRegisterServiceHistoryPopup = () => {
    this.openRegisterServiceHistoryPopup = false;
  };

  handleChangeFormSearchRegisterServiceHistory = (
    searchRegisterServiceHistory
  ) => {
    this.searchRegisterServiceHistory = {
      ...this.searchRegisterServiceHistory,
      ...searchRegisterServiceHistory,
    };
    this.fetchPagingRegisterServiceHistory();
  };

  fetchPagingRegisterServiceHistory = async () => {
    return await pagingRegisterServiceHistory({
      ...this.searchRegisterServiceHistory,
    })
      .then(({ data }) => {
        this.dataRegisterServiceHistory = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu lịch sử dịch vụ có lỗi");
      });
  };

  setSelectRegisterServiceId = (id) => {
    this.selectRegisterServiceId = id;
  };
  handleCloseConfirmMessage = () => {
    this.openConfirmMessage = null;
  };

  getTreatmentFree = async () => {
    return await pagingClientCard({
      pageIndex: 1,
      pageSize: PAGESIZE_ALL,
      keyword: TREATMENT_FREE,
      type: TYPE_CARD[1].value,
    })
      .then(({ data }) => {
        this.treatmentFree = data?.content?.[0];
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu hình thức thanh toán có lỗi");
      });
  };

  handleCloseHistoryServicePopup = async () => {
    this.openHistoryServicePopup = false;
    this.searchDataHistory = null;
  };

  handleChangeFormSearchHistory = (searchDataHistory) => {
    this.searchDataHistory = {
      ...this.searchDataHistory,
      ...searchDataHistory,
    };
    this.pagingHistory();
  };

  pagingHistory = async () => {
    return await elasticPatientServiceRegisterHistory({
      ...this.searchDataHistory,
    })
      .then(({ data }) => {
        this.pageDataHistory = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu lịch sử dịch vụ có lỗi");
      });
  };

  handleOpenHistoryServicePopup = async (values) => {
    try {
      this.handleChangeFormSearchHistory(values);
      this.openHistoryServicePopup = true;
    } catch (error) {
      toast.error(error);
    }
  };

  handleOpenUpdateTotalTreatmentPopup = async (obj) => {
    this.openUpdateTotalTreatment = obj;
  };

  handleCloseUpdateTotalTreatmentPopup = async () => {
    this.openUpdateTotalTreatment = null;
  };

  handleUpdateTotalTreatment = async (values) => {
    try {
      const { data } = await updateTotalTreatmentTimesOfService(
        values?.totaltreat ?? -1,
        values?.pasId
      );
      toast.success("Cập nhật thành công");

      this.openUpdateTotalTreatment = false;
      this.pagingAllServices();
    } catch (error) {
      toast.error(error);
    }
  };

  handleOpenGetTreatmentTimesEachServicesConfirm = async (obj) => {
    this.openTreatmentTimesEachServicesConfirm = obj;
  };

  handleCloseGetTreatmentTimesEachServicesConfirm = async () => {
    this.openTreatmentTimesEachServicesConfirm = null;
  };

  handleGetTreatmentTimesEachServices = async () => {
    try {
      const { data } = await getTreatmentTimesEachServices(
        this.openTreatmentTimesEachServicesConfirm
      );
      toast.success("Cập nhật thành công");

      this.openTreatmentTimesEachServicesConfirm = null;
      this.pagingAllServices();
    } catch (error) {
      toast.error(error);
    }
  };

  handleOpenHistoryTreamentServicePopup = async (
    patientServiceRegisterId,
    patientId
  ) => {
    try {
      this.searchHistoryTreamentService = {
        ...this.searchHistoryTreamentService,
        patientServiceRegisterId,
        patientId,
        getReport: true,
      };
      const { data } =
        await pagingServiceRequestItemByPatientServiceRegisterInfoGroupDate(
          this.searchHistoryTreamentService
        );

      this.pageHistoryTreamentService = data;
      this.openHistoryTreamentServicePopup = true;
    } catch (error) {
      console.error("Lỗi khi gọi API:", error);
      toast.error("Lấy dữ liệu dịch vụ đã điều trị có lỗi");
    }
  };

  handleChangeFormSearchHistoryTreamentService = async (
    searchHistoryTreamentService
  ) => {
    const payload = {
      ...this.searchHistoryTreamentService,
      ...searchHistoryTreamentService,
    };

    this.searchHistoryTreamentService = payload;

    try {
      const { data } =
        await pagingServiceRequestItemByPatientServiceRegisterInfoGroupDate(
          payload
        );
      this.pageHistoryTreamentService = data;
    } catch (error) {
      console.error("Lỗi khi phân trang:", error);
      toast.error("Phân trang dữ liệu dịch vụ điều trị có lỗi");
    }
  };

  handleCloseHistoryTreamentServicePopup = () => {
    this.openHistoryTreamentServicePopup = false;
    this.pageHistoryTreamentService = new PageResponse();
    this.searchHistoryTreamentService = new SearchObject();
  };

  handleCloseFormMainServiceRegister = () => {
    this.openFormMainServiceRegister = false;
    this.initialMainServiceRegister = null;
  };

  handleOpenFormMainServiceRegister = (row) => {
    this.openFormMainServiceRegister = true;
    this.initialMainServiceRegister = {
      id: row?.id,
      mainServiceRegister: row?.mainServiceRegister,
      patientId: row?.patientId,
    };
  };

  handleUpdateFormMainServiceRegister = async (values) => {
    try {
      const { data } = await updateMainServiceRegister(values);
      this.handleCloseFormMainServiceRegister();
      if (data) {
        toast.success("Cập nhật đơn hàng bảo hành thành công");
      } else {
        toast.error("Cập nhật đơn hàng bảo hành có lỗi");
      }
    } catch (error) {
      toast.error("Cập nhật đơn hàng bảo hành có lỗi");
    }
  };

  handleOpenWarrantyServicePopup = (row) => {
    this.initialWarrantyService = row;
    this.openWarrantyServicePopup = true;
  };
  handleCloseWarrantyServicePopup = () => {
    this.initialWarrantyService = null;
    this.openWarrantyServicePopup = false;
  };

  resetStore = () => {
    this.searchAllServices = {
      ...new SearchObject(),
      fromDate: new Date(new Date().getFullYear(), 0, 1),
      toDate: new Date(),
    };
    this.pageAllServices = new PageResponse();
    this.selectRegisterServiceId = null;
    this.searchRegisterServiceHistory = {
      ...new SearchObject(),
      patientServiceRegisterId: null,
    };
    this.openConfirmMessage = null;
    this.treatmentFree = null;
  };
}
